<template>
  <b-modal
    :id="id"
    class="basemodal"
    :title="title"
    :size="size"
    :okTitle="okTitle"
    :cancelTitle="cancelTitle"
    @ok="$emit('onOk', $event)"
    @hide="$emit('onClose', $event)"
  >
    <p class="basemodal__text">{{ text }}</p>
    <slot name="modal-content"></slot>
  </b-modal>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'sm'
    },
    okTitle: {
      type: String,
      default: '確定'
    },
    cancelTitle: {
      type: String,
      default: '取消'
    }
  }
};
</script>

<style lang="scss" scoped>
.basemodal {
  &__text {
    color: #f00;
  }
}

::v-deep .btn {
  padding: 10px 20px;
}

::v-deep .btn-secondary {
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  margin-right: 20px;
  &:hover {
    background: #606266;
    border: 1px solid #606266;
    color: #fff;
  }
}
</style>
